import {
  type ISingleFileViewerProps,
  SingleFileViewer,
} from './SingleFileViewer'
import { Modal } from '../Modal'
import { SingleFileViewerModalStyled } from './styles/SingleFileViewerModalStyled'
import { TransparentIconButton } from '@ui/elements/Button'

export interface ISingleFileViewerModalProps extends ISingleFileViewerProps {
  open?: boolean
  onDismiss?: () => void
}

export const SingleFileViewerModal = ({
  open = false,
  onDismiss = () => undefined,
  ...SingleFileViewerProps
}: ISingleFileViewerModalProps) => {
  return (
    <Modal
      maxWidth='sm'
      open={open}
      onClose={onDismiss}
      disableEnforceFocus
      fullScreen
    >
      <SingleFileViewerModalStyled>
        <SingleFileViewer {...SingleFileViewerProps} />
        <TransparentIconButton
          icon='times'
          onClick={onDismiss}
          iconColor='textInverse'
          aria-label='Close file viewer'
          className='close-button'
        />
      </SingleFileViewerModalStyled>
    </Modal>
  )
}

SingleFileViewerModal.displayName = 'SingleFileViewerModal'
